import Index from 'src/pages/Warehouses/Products/Index.vue'
import ToOrder from 'src/pages/Warehouses/Products/ToOrder.vue'

const auth = { requiresAuth: true }

export default [
  {
    path: '/warehouses/:id/products',
    name: 'Produkte Lager',
    component: Index,
    meta: auth
  },
  {
    path: '/warehouses/:id/products/to_order',
    name: 'Zu Bestellende Produkte',
    component: ToOrder,
    meta: auth
  }
]
